import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M8 4 5 3l2-3h10l2 3-3 1V2H8v2Zm12 3h-5l-1-3h-4L9 7H4l-1 3 2 1 1-1h12l1 1 2-1-1-3Zm-1 17h-3v-1l-4-6-4 6v1H5l4-13h2v1l1 3 1-3v-1h2l4 13Zm-8-8-1-2-1 5 2-3Zm4 3-1-5-1 2 2 3Z"/>',
  f: '<path d="M8 4 5 3l2-3h10l2 3-3 1V2H8v2Zm12 3h-5l-1-3h-4L9 7H4l-1 3 2 1 1-1h12l1 1 2-1-1-3Zm-1 17h-3v-1l-4-6-4 6v1H5l4-13h2v1l1 3 1-3v-1h2l4 13Zm-8-8-1-2-1 5 2-3Zm4 3-1-5-1 2 2 3Z"/>',
  vb: '-2 0 24 24',
};

export default data;
